import React from 'react';

const Subtitulo = (props) => {  

    let subtitulo;
    if (props.subTitulo != undefined) {
        subtitulo = <div className="col-xs-12">
            <h3>
                Confirmación de solicitud {props.entidad} "{props.subTitulo}"
                </h3>
        </div>
    }
    else {
        subtitulo = <div className="col-xs-12">
            <h3>
                Confirmación de solicitud {props.entidad}
                </h3>
        </div>
    }

    return (
        <div className="row">
            {subtitulo}
        </div>
    );
}

export default Subtitulo;